import {
   clearCqrsWebsocketClient,
   registerCqrsClient,
   registerCqrsGateway,
   registerCqrsWebsocketClient,
   setCqrsLogger,
} from '@dreryk/command-query-react-common';
import { Gateway } from '@dreryk/command-query-ws-client';
import { Unsubscribe, WebSocketGateway } from '@dreryk/websocket-client';
import { asyncRejection } from '@dreryk/egabinet-security-frontend';
import { initializeDraftService } from '@dreryk/react-draft';
import { createLogger } from '@dreryk/typescript-logger';

import { resolveWebsocketUrl } from './resolveWebsocketUrl';

const logger = createLogger('CQRS');
setCqrsLogger({
   error: (...args) => logger.error(() => args),
   log: (...args) => logger.info(() => args),
   warn: (...args) => logger.warn(() => args),
});

registerCqrsGateway(
   'egabinet-security-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-security-frontend-api')
);
registerCqrsGateway('egabinet-ezla-frontend-api', new Gateway('/services/rest/cqrs/1.0/egabinet-ezla-frontend-api'));
registerCqrsGateway(
   'egabinet-referral-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-referral-frontend-api')
);
registerCqrsGateway('egabinet-p1-frontend-api', new Gateway('/services/rest/cqrs/1.0/egabinet-p1-frontend-api'));
registerCqrsGateway(
   'egabinet-advertisement-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-advertisement-frontend-api')
);
registerCqrsGateway(
   'egabinet-appointment-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-appointment-frontend-api')
);
registerCqrsGateway(
   'egabinet-phone-notification-frontend',
   new Gateway('/services/rest/cqrs/1.0/egabinet-phone-notification-frontend')
);
registerCqrsGateway('statistics-frontend', new Gateway('/services/rest/cqrs/1.0/statistics-frontend'));
registerCqrsGateway('egabinet-ezwm-frontend-api', new Gateway('/services/rest/cqrs/1.0/egabinet-ezwm-frontend-api'));
registerCqrsGateway(
   'egabinet-nfz-configuration-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-nfz-configuration-frontend-api')
);
registerCqrsGateway(
   'egabinet-private-medical-service-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-private-medical-service-frontend-api')
);
registerCqrsGateway(
   'egabinet-rpwdl-integration-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-rpwdl-integration-frontend-api')
);
registerCqrsGateway(
   'egabinet-financial-settlement-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-financial-settlement-frontend-api')
);
registerCqrsGateway(
   'egabinet-docplanner-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-docplanner-frontend-api')
);
registerCqrsGateway(
   'egabinet-patient-portal-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-patient-portal-frontend-api')
);
registerCqrsGateway(
   'egabinet-icd-dictionary-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-icd-dictionary-frontend-api')
);

registerCqrsGateway(
   'egabinet-invoice-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-invoice-frontend-api')
);

registerCqrsGateway(
   'egabinet-survey-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-survey-frontend-api')
);

registerCqrsGateway(
   'egabinet-discharge-summary-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-discharge-summary-frontend-api')
);

registerCqrsGateway(
   'egabinet-online-payments-integration-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-online-payments-integration-frontend-api')
);

registerCqrsGateway(
   'egabinet-document-repository-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-document-repository-frontend-api')
);
registerCqrsGateway(
   'egabinet-document-template-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-document-template-frontend-api')
);
registerCqrsGateway('egabinet-demo-frontend-api', new Gateway('/services/rest/cqrs/1.0/egabinet-demo-frontend-api'));
registerCqrsGateway(
   'egabinet-dashboard-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-dashboard-frontend-api')
);

registerCqrsGateway(
   'egabinet-appointment-advance-payment-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-appointment-advance-payment-frontend-api')
);
registerCqrsGateway(
   'egabinet-healthcare-provider-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-healthcare-provider-frontend-api')
);
registerCqrsGateway(
   'egabinet-patient-access-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-patient-access-frontend-api')
);
registerCqrsGateway(
   'egabinet-patient-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-patient-frontend-api')
);
registerCqrsGateway(
   'egabinet-patient-medical-information-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-patient-medical-information-frontend-api')
);
registerCqrsGateway('egabinet-ewus-frontend-api', new Gateway('/services/rest/cqrs/1.0/egabinet-ewus-frontend-api'));
registerCqrsGateway(
   'egabinet-patient-entitlement-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-patient-entitlement-frontend-api')
);
registerCqrsGateway(
   'egabinet-personal-certificate-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-personal-certificate-frontend-api')
);
registerCqrsGateway(
   'egabinet-personnel-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-personnel-frontend-api')
);
registerCqrsGateway(
   'egabinet-pre-interview-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-pre-interview-frontend-api')
);
registerCqrsGateway(
   'egabinet-prescription-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-prescription-frontend-api')
);
registerCqrsGateway('egabinet-visit-frontend-api', new Gateway('/services/rest/cqrs/1.0/egabinet-visit-frontend-api'));

registerCqrsGateway(
   'egabinet-video-call-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-video-call-frontend-api')
);

registerCqrsGateway(
   'egabinet-knowledge-base-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-knowledge-base-frontend-api')
);

registerCqrsGateway(
   'egabinet-waitlist-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-waitlist-frontend-api')
);

registerCqrsGateway(
   'egabinet-group-session-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-group-session-frontend-api')
);

registerCqrsGateway(
   'egabinet-adamed-expert-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-adamed-expert-frontend-api')
);

registerCqrsGateway(
   'egabinet-medical-data-confidentiality-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-medical-data-confidentiality-frontend-api')
);

registerCqrsGateway(
   'egabinet-emergency-notification-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-emergency-notification-frontend-api')
);

registerCqrsGateway(
   'egabinet-ai-assistant-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-ai-assistant-frontend-api')
);

registerCqrsGateway(
   'egabinet-user-inbox-frontend-api',
   new Gateway('/services/rest/cqrs/1.0/egabinet-user-inbox-frontend-api')
);

registerCqrsGateway('eGabinetHealthcareProvider', new Gateway('/services/rest/cqrs/1.0/eGabinetHealthcareProvider'));

registerCqrsGateway('medicineDatabasePharmindex', new Gateway('/services/rest/cqrs/1.0/medicineDatabasePharmindex'));

registerCqrsGateway('medicalDictionaries', new Gateway('/services/rest/cqrs/1.0/medicalDictionaries'));

registerCqrsGateway('drerykwebMedicine', new Gateway('/services/rest/cqrs/1.0/drerykwebMedicine'));

registerCqrsGateway('drerykwebEzla', new Gateway('/services/rest/cqrs/1.0/drerykwebEzla'));

registerCqrsGateway('drerykwebReferral', new Gateway('/services/rest/cqrs/1.0/drerykwebReferral'));

registerCqrsGateway(
   'drerykwebMedicalDictionaries',
   new Gateway('/services/rest/cqrs/1.0/drerykwebMedicalDictionaries')
);

registerCqrsGateway('eGabinetVisit', new Gateway('/services/rest/cqrs/1.0/eGabinetVisit'));

initializeDraftService();

registerCqrsClient({
   onError: asyncRejection,
});

export const connectCqrsWebsocketClient = (): Unsubscribe => {
   const cqrsWebsocketClient = new WebSocketGateway(resolveWebsocketUrl('/websocket'));
   registerCqrsWebsocketClient(cqrsWebsocketClient);
   cqrsWebsocketClient.connect();
   return clearCqrsWebsocketClient;
};

export { CqrsClientProvider } from '@dreryk/command-query-react-common';
